import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  margin-block-end: 72px;

  border-radius: 12px;

  background: #d4e0f2;
`;

export const Head = styled.div`
  padding-block: 28px 20px;
  padding-inline: 28px;
  border-block-end: 2px solid #f7f6ef;
`;

export const Contents = styled.div`
  display: flex;
  flex-direction: column;

  padding-block: 24px 28px;
  padding-inline: 28px;

  color: #000000;

  ${theme.breakpoints.up("mediumDesktop")} {
    flex-direction: row;
  }
`;

export const Headline = styled.div`
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;
`;

type DescriptionWrapperProps = {
  $isFullSize: boolean;
};
export const DescriptionWrapper = styled.div<DescriptionWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;
  margin-inline-end: 24px;

  ${theme.breakpoints.up("mediumDesktop")} {
    inline-size: ${props => (props.$isFullSize ? "100%" : "218px")};
  }
`;

export const Description = styled.div`
  font-size: 18px;
  font-family: ${fontRobotoCondensed};
  line-height: 130%;

  a {
    display: inline;

    color: #4585ff;
    text-decoration-line: underline;
    &:hover {
      color: #2c4692;
    }
  }
  * + * {
    margin-block-start: 20px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
  }
  ol {
    padding-inline-start: 30px;

    list-style: decimal;
  }
  ul li {
    position: relative;

    margin-inline-start: 25px;
    &:before {
      position: absolute;
      inset-inline-start: -15px;
      content: "•";
    }
  }
  sup {
    font-size: smaller;
    vertical-align: super;
  }
  sub {
    font-size: smaller;
    vertical-align: sub;
  }
`;

export const Content = styled.div``;

export const ContentsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;

  margin-block-start: 24px;
  padding-block-start: 24px;
  border-block-start: 2px solid #f7f6ef;

  ${Content} + ${Content} {
    padding-block-start: 16px;
    border-block-start: 2px solid #f7f6ef;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    margin-block-start: 0;
    padding-block-start: 0;
    padding-inline-start: 24px;
    border-block-start: initial;
    border-inline-start: 2px solid #f7f6ef;
  }
`;
